import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => (
  <footer className="bg-[#07000d] border-t border-white/[0.04]">
    <div className="max-w-6xl mx-auto px-6 lg:px-8 py-14">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div className="space-y-3">
          <img src="/assets/images/logo2.svg" alt="BuilderThinking" className="h-7 w-auto opacity-70" />
          <p className="text-sm text-white/25 max-w-xs leading-relaxed">
            AI consulting for small businesses that want results, not more confusion.
          </p>
        </div>
        <div className="flex gap-10 text-sm">
          <Link to="/" className="text-white/30 hover:text-white/60 transition-colors">Home</Link>
          <Link to="/products" className="text-white/30 hover:text-white/60 transition-colors">Products</Link>
          <Link to="/consulting" className="text-white/30 hover:text-white/60 transition-colors">Consulting</Link>
          <Link to="/masterclass" className="text-white/30 hover:text-white/60 transition-colors">Masterclass</Link>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-white/[0.04] text-center">
        <p className="text-xs text-white/15">&copy; {new Date().getFullYear()} BuilderThinking. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
